// import { ApolloProvider } from "@apollo/client"

import { ApolloProvider } from "@apollo/client"
import React from "react"
import client from "./client"

// Uncomment to used div as root and build works
// export const wrapRootElement = ({ element }) => <div>{element}</div>

export const wrapRootElement = ({ element }) => (
  <ApolloProvider client={client}>{element}</ApolloProvider>
)
